export const API_URL = "https://EndPointTesting.aud.edu";
//  export const API_URL = "https://audapitesting.ctsdemo.ae";
